import { render, staticRenderFns } from "./yhAdvertisingManageList.vue?vue&type=template&id=2b9128ef&"
import script from "./yhAdvertisingManageList.vue?vue&type=script&lang=js&"
export * from "./yhAdvertisingManageList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports